import { Spinner } from "@relex-solutions/fragments"
import styles from "./Loading.module.css"

interface LoadingProps {
  text?: string
}

export function Loading({ text }: LoadingProps) {
  return (
    <div className={styles.loadingContainer} data-testid="loading-container">
      <Spinner size="medium" />
      <p>{text}</p>
    </div>
  )
}
